<template>
	<NuxtLink
		v-if="isEnabled && !isHidden"
		:to="localePath('/right-of-withdrawal')"
		class="text-sm underline underline-offset-2 hover:no-underline"
	>
		{{ $t("withdrawal.footer_link") }}
	</NuxtLink>
</template>

<script setup lang="ts">
const localePath = useLocalePath();
const { footer } = storeToRefs(useAppStore());
const isEnabled = useWithdrawalEnabled();

/**
 * Opt-out lives on the `layouts/main` Storyblok story so clients can flip it
 * without Vercel access.
 *
 * The field is deliberately named `hide_…` rather than `show_…`: Storyblok
 * booleans are absent/false by default, so a "show" flag would evaluate false
 * on every existing story and silently drop a legally required link. Phrasing
 * it as "hide" makes link-visible the zero-config default.
 */
const isHidden = computed(() => Boolean(footer.value?.hide_withdrawal_link));
</script>
